<template>
  <div
    v-if="displaySocialLinks"
    class="social-links d-flex flex-row align-center justify-center"
  >
    <a
      v-for="(link, index) in normalizedSocialLinks"
      :key="index"
      :data-cy="`social-link-${link.name}`"
      :href="link.link"
      target="_blank"
      rel="noopener noreferrer"
      class="social-item"
      :style="{ color: link.color }"
    >
      <SocialIcons
        :name="link.name"
        :style="{ width: link.size, height: link.size }"
      />
    </a>
  </div>
</template>

<script>
import SocialIcons from '@/assets/icons/SocialIcons.vue';

export default {
  components: {
    SocialIcons,
  },
  props: {
    socialLinks: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    displaySocialLinks() {
      return this.socialLinks.length > 0;
    },
    normalizedSocialLinks() {
      if (!this.socialLinks.length) return [];

      return this.socialLinks.map(link => {
        return {
          ...link,
          size: link.size ? `${link.size}px` : '20px',
          color: link.color || '#262626',
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.social-links {
  gap: 8px;
}

.social-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}
</style>
